import styled from 'styled-components'

export const PageHeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  margin-bottom: 24px;

  h1 {
    font-size: 20px;
    color: #000;
    font-weight: bold;
    margin-bottom: 0;
  }
`
